/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
/**
 * Check to see if the input dir parameter is RTL.
 *
 * @memberof module:base/util
 * @param {String} dir - String to be checked.
 * @return {Boolean} True if the string is rtl, false otherwise.
 */
var isRTL = function isRTL(dir) {
  return (dir === null || dir === void 0 ? void 0 : dir.toLowerCase()) === 'rtl';
};
export default isRTL;